// src/features/explore/DecorativeMotif.tsx — abstract, low-opacity SVG overlay drawn on
// top of a decorative-cover gradient. Purely ornamental (no semantic meaning, owner
// decision) — always aria-hidden. Theme-safe: dark theme draws in low-opacity white
// (reads over the near-black-to-neon dark gradients); light theme draws in low-opacity
// ink (white would vanish over the light gradients' near-white base).
import type { DecorativeMotif as MotifId, ThemeMode } from './decorativeCover';

export interface DecorativeMotifProps {
  motif: MotifId;
  mode: ThemeMode;
}

export function DecorativeMotif({ motif, mode }: DecorativeMotifProps) {
  const stroke = mode === 'dark' ? '#FFFFFF' : '#1B1030';
  return (
    <svg
      viewBox="0 0 200 120"
      width="100%"
      height="100%"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
      focusable="false"
      style={{ position: 'absolute', inset: 0 }}
    >
      <g fill="none" stroke={stroke} strokeWidth="1.25" opacity="0.22">
        {motif === 'waves' && (
          <>
            <path d="M -10 30 Q 40 10 90 30 T 190 30" />
            <path d="M -10 60 Q 40 40 90 60 T 190 60" />
            <path d="M -10 90 Q 40 70 90 90 T 190 90" />
          </>
        )}
        {motif === 'grid' && (
          <>
            <path d="M 0 20 H 200 M 0 50 H 200 M 0 80 H 200 M 0 110 H 200" />
            <path d="M 30 0 V 120 M 70 0 V 120 M 110 0 V 120 M 150 0 V 120 M 190 0 V 120" />
          </>
        )}
        {motif === 'orbs' && (
          <>
            <circle cx="40" cy="30" r="16" />
            <circle cx="150" cy="45" r="26" />
            <circle cx="100" cy="95" r="12" />
            <circle cx="175" cy="100" r="8" />
          </>
        )}
        {motif === 'rings' && (
          <>
            <circle cx="100" cy="60" r="16" />
            <circle cx="100" cy="60" r="34" />
            <circle cx="100" cy="60" r="52" />
          </>
        )}
      </g>
    </svg>
  );
}
